<template>
    <div>
        <div v-if="diff.formattedDiffs.existants.length === 0 && diff.formattedDiffs.new.length === 0">
            <div class="border border-secondary mt-2">
                <v-chip class="m-2" color="white"></v-chip>
            </div>
        </div>
        <div class="border border-secondary d-flex" v-else>
            <div v-for="element in diff.formattedDiffs.existants" class="d-flex">
                <v-chip class="m-2">{{ element.label }}</v-chip>
            </div>
            <div v-for="element in diff.formattedDiffs.new" class="d-flex">
                <v-chip class="m-2" :color="addColors.light">
                    <v-icon color="green">
                        add
                    </v-icon>
                    <span :style="'color:' + addColors.deep">
                                {{ element.label }}
                            </span>
                </v-chip>
            </div>
        </div>
        <div class="d-flex">
            <div class="mt-2" v-for="element in diff.formattedDiffs.old">
                <v-chip :color="deleteColors.light" class="m-2">
                    <v-icon color="red">
                        remove
                    </v-icon>
                    <span :style="'color:' + deleteColors.deep">
                                {{ element.label }}
                            </span>
                </v-chip>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex"

export default {
    name: "ElementFieldDiffs",
    props: ["diff"],
    computed: {
        ...mapState("sitAnswer", [
            "addColors",
            "updateColors",
            "deleteColors",
        ]),
    },
}
</script>